export default __webpack_public_path__ + "static/media/logo.51f355ff.png";